import type { JobTitle, JobTitleDto } from '../types';

export function jobTitleFromDto(dto: JobTitleDto): JobTitle {
  return {
    id: dto.id,
    title: dto.joti_title,
  };
}
